var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import Button from 'syf-component-library/ui/atoms/Button/Button';
import styled from 'styled-components';
export var OnlineChatButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n"], ["\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n"])));
var templateObject_1;
